// --- External Libraries
import moment from 'moment-timezone';
// --- Components
import { CustomHeader } from 'datastage/components/AGGrid/cell-renderers/custom-header';

export const id = {
    field: 'jobId',
    headerName: 'Job',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'id',
        page: 'jobTasks',
    }
};

export const taskStatus = {
    field: 'taskStatus',
    headerName: 'Status',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'taskStatus',
        page: 'jobTasks',
    }
};

export const taskDetails = {
    field: 'taskDetails',
    headerName: 'Details',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'taskDetails',
        page: 'jobTasks',
    }
};

export const statusMessage = {
    field: 'statusMessage',
    headerName: 'Message',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'statusMessage',
        page: 'jobTasks',
    }
};

export const createdAt = {
    field: 'createdAt',
    headerName: 'Created',
    valueFormatter: ({ value }) => (value ? moment(value).tz(moment.tz.guess()).format('MMM-DD-YYYY, h:mm:ss A z') : ''),
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'createdAt',
        page: 'jobTasks',
    }
};

export const modifiedAt = {
    field: 'modifiedAt',
    headerName: 'Modified',
    valueFormatter: ({ value }) => (value ? moment(value).tz(moment.tz.guess()).format('MMM-DD-YYYY, h:mm:ss A z') : ''),
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'modifiedAt',
        page: 'jobTasks',
    }
};


export const completedAt = {
    field: 'completedAt',
    headerName: 'Completed',
    valueFormatter: ({ value }) => (value ? moment(value).tz(moment.tz.guess()).format('MMM-DD-YYYY, h:mm:ss A z') : ''),
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'completedAt',
        page: 'jobTasks',
    }
};
